import React from 'react';

const Why = () => {
    return (
        <div className="py-5 why">
            <div className="text-center py-4">
                <h1 className="py-2 display-4 text-uppercase"><span className="text-warning">Why</span> TRAVEL</h1>
                <p>Mollit voluptatem perspiciatis convallis elementum corporis quo veritatis aliquid blandit.</p>
            </div>
            <div className="container">
                <div className="row g-3">
                    <div className="col-lg-3 col-md-6 col-6">
                    <div className="card h-100 shadow">
                      <div className="card-body">
                          <h3>2000+ Our World Wide Guide</h3>
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                    <div className="card h-100 shadow">
                      <div className="card-body">
                          <h3>100% Trusted Agency</h3>
                      </div>
                  </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                    <div className="card h-100 shadow">
                      <div className="card-body">
                          <h3>10+ year of travel experience</h3>
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                    <div className="card h-100 shadow">
                      <div className="card-body">
                          <h3>90% of our traveller happy</h3>
                      </div>
                    </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Why;